// Components==============
import { useRedux } from 'hooks/useRedux';
import React, { useEffect, useState } from 'react';
import './Avatar.module.scss';
// =========================

export default function Avatar({
  user,
  size = 'small',
  span,
  border,
}: {
  user?: UserEntity | UserAuthenticationEntity;
  size?: 'small' | 'medium' | 'medium-big' | 'big' | 'huge';
  span?: boolean;
  border?: boolean;
}) {
  const currentUser = useRedux((state) => state.authentication?.user);
  const [avatarImageExists, setAvatarImageExists] = useState(true);
  const [count, setCount] = useState(0);

  const displayUser = user || currentUser;

  const dimensions = span
    ? '100%'
    : size === 'small'
    ? 35
    : size === 'medium'
    ? 50
    : size === 'medium-big'
    ? 60
    : size === 'big'
    ? 100
    : 200;

  useEffect(() => {
    if (displayUser?.avatar_url && count > 0) {
      setAvatarImageExists(true);
    }
    setCount((prev) => prev + 1);
  }, [displayUser?.avatar_url]);

  return (
    <>
      {!displayUser?.avatar_url || !avatarImageExists ? (
        <div styleName="icon" style={{ width: dimensions, height: dimensions }}>
          <p styleName={size}>
            {`${displayUser?.first_name[0]} ${displayUser?.last_name[0]}`}
          </p>
        </div>
      ) : (
        <div
          styleName={`${size === 'huge' ? 'huge' : ''} ${
            border ? 'with-border' : ''
          }`}
          style={{
            width: dimensions,
            height: dimensions,
          }}
        >
          <img
            styleName="image"
            src={displayUser?.avatar_url}
            alt={displayUser?.first_name}
            onError={() => setAvatarImageExists(false)}
            onLoad={() => setAvatarImageExists(true)}
          />
        </div>
      )}
    </>
  );
}
